import $ from 'jquery';
import {loadStripeSDK} from '@wc-stripe/stripe-sdk';
import {isNextActionRequired} from '@wc-stripe/utils';

const localizedData = cartflows_offer.stripeData;

let currentButton;

const initialize = () => {
    window.addEventListener('hashchange', handleHashChange);
    $(document.body).on('click', 'a[href*="wcf-up-offer"], a[href*="wcf-down-offer"]', handleButtonClick);
}

const handleButtonClick = (e) => {
    currentButton = $(e.currentTarget);
}

const handleHashChange = async (e) => {
    const data = isNextActionRequired(e.newURL);
    if (data) {
        try {
            const stripe = await loadStripeSDK();
            const response = await stripe.confirmPayment({
                clientSecret: data.client_secret,
                redirect: 'if_required',
            });
            if (response.error) {
                $('body').trigger('wcf-update-msg', [response.error.message, 'wcf-payment-error']);
                setTimeout(() => {
                    $(document.body).trigger('wcf-hide-loader')
                    $(document.body).trigger('wcf-update-msg', [localizedData.msg, 'wcf-payment-success']);
                    currentButton.attr('disabled', false);
                }, localizedData.timeout);
            } else {
                currentButton.attr('disabled', false);
                currentButton.trigger('click');
            }
        } catch (err) {
            console.error(err);
        }
    }
}

const triggerOfferClick = () => {
    currentButton.trigger('click');
}

initialize();